import React from 'react';
import NoticeStrip from './NoticeStrip';

// ===========================================================================
// SignInNotice
//
// A deliberately narrow, one-shot strip shown once on a single transition: the
// moment an email-confirmation link resolves — into a live session ("you are signed
// in"), or into nothing because the link had expired or was already used.
// See docs/briefs/2026-09-15-fix-stale-session-guard-post-confirmation.md items 3 and 4.
// 2026-10-03 (Roadmap #88, registration confirm-first): the two setup-failure statuses
// are retired — nothing is created on sign-in any more (AccountSetup does it, and
// reports its own failures) — and 'link-failed' replaces them (Advisor A8).
//
// It is now a thin CALLER of NoticeStrip rather than its own strip. The rendering
// is unchanged — NoticeStrip carries the markup this component used to hold, and
// the statuses below map onto its props one-for-one.
//
// Why it changed: the previous header here said that if a second, unrelated
// message ever needed showing, that was the point to design the surface properly
// rather than add a fourth status. That message arrived (the demo expired-session
// notice, docs/briefs/2026-09-25-demo-read-expired-session.md + addendum 1) and
// the Architect ruled accordingly — generalise, do not special-case. So the rule
// stands and was followed: there is still no fourth status here, and there is no
// fourth status anywhere. A new message renders NoticeStrip directly.
//
// This component keeps exactly the job it always had: the sign-in statuses, and
// nothing else. Do not add unrelated statuses to the map below — render
// NoticeStrip instead, as the demo notice does.
// ===========================================================================

// Status → { translation key, tone }. Tone drives colour only.
const STATUS_MAP = {
  'signed-in':   { key: 'signin_ack',         tone: 'success' },
  'link-failed': { key: 'signin_link_failed', tone: 'error'   }
};

const SignInNotice = ({ status, onDismiss }) => {
  const entry = STATUS_MAP[status];
  if (!entry) return null;

  return (
    <NoticeStrip
      messageKey={entry.key}
      namespace="auth"
      tone={entry.tone}
      onDismiss={onDismiss}
    />
  );
};

export default SignInNotice;
